import {Component, HostListener, Inject, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {HttpErrorService} from '@core/services/http-error.service';
import {WINDOW} from '@shared/services/window.service';
import {CommonModule} from '@angular/common';


@Component({
	selector: 'app-http-error',
	templateUrl: './http-error.component.html',
	styleUrls: ['./http-error.component.scss'],
	standalone: true,
	imports: [CommonModule]
})

export class HttpErrorComponent implements OnDestroy {
	public showMessage: boolean;
	public siteOrigin: string;
	private destroy$ = new Subject<void>();

	constructor(
		private httpErrorService: HttpErrorService,
		@Inject(WINDOW) private window: Window
	) {
		this.siteOrigin = `${window.location.origin}/census-search`;

		this.httpErrorService.show$.pipe(
			tap(() => this.show()),
			takeUntil(this.destroy$)
		).subscribe();
	}

	@HostListener('window:popstate', ['$event'])
	onPopState() {
		this.hide();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	public goToHomePage(): void {
		this.window.location.href = window.location.origin;
	}

	// Show message
	private show(): void {
		this.showMessage = true;
	}

	// Hide message
	private hide(): void {
		this.showMessage = false;
	}
}
